import { ICreativity, Status } from '../creativities/types';
import { IPlaylist } from './types';

export const isPublishedCreativity = (creativity?: ICreativity | null) =>
  !!creativity &&
  (!!creativity.publishedAt || creativity.status === Status.PUBLISHED);

export const getPlaylistErrors = (
  playlist: IPlaylist,
  creativities: ICreativity[]
) => {
  const errors: string[] = [];
  const ids = playlist.items.map(item => item.creativity);
  const uniqueIds = new Set(ids);

  if (!playlist.name || !playlist.name.trim()) {
    errors.push('playlist.validation.name');
  }

  if (
    !playlist.allPlayers &&
    !(playlist.players && playlist.players.length) &&
    !(playlist.groups && playlist.groups.length)
  ) {
    errors.push('playlist.validation.target');
  }

  if (!playlist.items.length) {
    errors.push('playlist.validation.items');
  }

  if (uniqueIds.size !== ids.length) {
    errors.push('playlist.validation.duplicates');
  }

  return errors;
};
